import React from 'react';
import styles from './StyleComponents.module.css';

type HeadingProps = {
  color?: string;
  align?: string;
  className?: string;
  children?: React.ReactNode;
};

export const H2 = ({ color, align, className, children }: HeadingProps) => (
  <h2
    className={`${styles.h2}${className ? ` ${className}` : ''}`}
    style={
      { ['--color']: color || 'black', ['--align']: align || 'center' } as React.CSSProperties
    }
  >
    {children}
  </h2>
);

export const H3 = ({ color, align, className, children }: HeadingProps) => (
  <h3
    className={`${styles.h3}${className ? ` ${className}` : ''}`}
    style={
      { ['--color']: color || 'black', ['--align']: align || 'center' } as React.CSSProperties
    }
  >
    {children}
  </h3>
);

export const P = ({ color, align, className, children }: HeadingProps) => (
  <p
    className={`${styles.p}${className ? ` ${className}` : ''}`}
    style={
      { ['--color']: color || 'black', ['--align']: align || 'center' } as React.CSSProperties
    }
  >
    {children}
  </p>
);
